import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { meQuery } from '@/lib/queries';

/** Signed-out screens. A signed-in visitor is sent straight to the dashboard. */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context }) => {
    // Any failure (401, network) means "show the signed-out screen".
    const signedIn = await context.queryClient.fetchQuery({ ...meQuery, staleTime: 0 }).then(
      () => true,
      () => false,
    );
    if (signedIn) throw redirect({ to: '/' });
  },
  component: Outlet,
});
